import { createRoot, type Container } from 'react-dom/client';

export const handleCloseClick = function (event:Event, root:Container) {
    event.preventDefault();
    const newRoot = createRoot(root);
    newRoot.unmount();
};

// We often want to just append a value to the existing rf during A/B tests
export const appendToTrackingLinkRF = (url:string, rf:string|nullish) => {
    if (!rf || rf === '') {
        return url;
    }
    const trackerUrl = new URL(decodeURIComponent(url));
    const newRf = trackerUrl.searchParams.get('rf') + '-' + rf;
    trackerUrl.searchParams.set('rf', newRf);
    return encodeURIComponent(trackerUrl.toString());
};
